module.exports = __webpack_public_path__ + "assets/483df755bac0001945dc55217d4d92c8.png";